var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDisabledNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 15,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 9C11.4387 9 11.54 9.01867 11.604 9.056C11.6733 9.088 11.7507 9.15733 11.836 9.264L18.476 17.904C18.46 17.7653 18.4493 17.632 18.444 17.504C18.4387 17.3707 18.436 17.2427 18.436 17.12V9H19.796V20.464H19.012C18.8893 20.464 18.7853 20.4427 18.7 20.4C18.62 20.3573 18.54 20.2853 18.46 20.184L11.828 11.552C11.8387 11.6853 11.8467 11.816 11.852 11.944C11.8573 12.072 11.86 12.1893 11.86 12.296V20.464H10.5V9H11.3Z",
    fill: "#C7C7C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDisabledNo);
export default __webpack_public_path__ + "static/media/ic-disabled-no.20a04426.svg";
export { ForwardRef as ReactComponent };